var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deck-container"},[_c('div',{ref:"map",attrs:{"id":"map"}}),_c('Modal',{attrs:{"show":_vm.showModal,"info":_vm.containerDetails,"location":_vm.location},on:{"closeModal":function($event){_vm.showModal = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }